module.exports = __webpack_public_path__ + "static/in-the-heart-of-the-sea-f4d15c8602a4d7bf53f814819f6c0830.jpg";